// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LBab","icon":"styles_icon__gPjQR"};